<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="商品ID" class='tiny'>
						<el-input style="width:300px;" v-model="searchInfo.goodsId" placeholder="请输入商品ID">
						</el-input>
					</el-form-item>
					<el-form-item label="商品名称" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="searchInfo.goodsName" placeholder="请输入商品名称"></el-input>
					</el-form-item>
					<el-form-item label="商品编号" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="searchInfo.goodsCode" placeholder="请输入商品编号"></el-input>
					</el-form-item>
					<el-form-item label="商品状态" class='tiny' cleartable>
						<el-select v-model="searchInfo.status" placeholder="请选择商品状态">
							<el-option key="0" label="下架" :value="0">下架</el-option>
							<el-option key="1" label="上架" :value="1">上架</el-option>
						</el-select>
					</el-form-item>
					
					
				
				<el-form-item label="供应商名称" class='tiny' cleartable v-if="storeType!=2">
					<el-select v-model="searchInfo.storeId" placeholder="请选择供应商名称">
						<el-option v-for="item in storeList" :key="item.id" :value="item.id"
							:label="item.storeName">
						</el-option>
					</el-select>
				</el-form-item>
		
				<el-form-item label="商品分类" style="width: 100%;">
				
					<el-select clearable v-model="classGoods1Id" placeholder="请选择分类" style="margin-right:10px;"
						@change="classGoods1" filterable>
						<el-option clearable v-for="item in classGoods1List" :key="item.id" :label="item.className"
							:value="item.id">
						</el-option>
					</el-select>
				
					<el-select clearable v-model="classGoods2Id" placeholder="请选择二级分类"
						style="width:30%;margin:0px 10px;" @change="classGoods2">
						<el-option v-for="item in classGoods2List" :key="item.id" :label="item.className"
							:value="item.id">
						</el-option>
					</el-select>
				
					<el-select clearable v-model="classGoods3Id" placeholder="请选择三级分类"
						style="width:30%;margin:0px 10px;" @change="classGoods3">
						<el-option v-for="item in classGoods3List" :key="item.id" :label="item.className"
							:value="item.id">
						</el-option>
					</el-select>
				
				</el-form-item>

					<template>
						<el-button type="primary" @click="search">查询</el-button>
						<el-button @click="empty">清空</el-button>
				<!-- <el-button type="primary" @click="goxuanp">去选品</el-button> -->
						<!-- <el-button type="primary" @click="downloadFile"> 导出 </el-button> -->
					</template>
					</el-form-item>
				</el-form>
			</header>
		</div>
		<el-table :data="goodsList.list" stripe style="width: 100%;" :header-cell-style="headClass" v-loading="loading"
			element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
			<el-table-column type="expand">
				<template slot-scope="props">
					<el-form label-position="left" inline class="demo-table-expand">
						<el-form-item label="供应商" v-if="storeType!=2">
							<span v-if="props.row.storeId!=0">{{ props.row.storeName }}</span>
							<span v-else>无</span>
						</el-form-item>
						<el-form-item label="商品ID">
							<span>{{ props.row.id }}</span>
						</el-form-item>
						<el-form-item label="商品名称">
							<span>{{ props.row.goodsName }}</span>
						</el-form-item>
						<el-form-item label="商品编号">
							<span>{{ props.row.goodsCode?props.row.goodsCode:'无' }}</span>
						</el-form-item>
						<el-form-item label="市场价">
							<span>￥{{ props.row.marketPrice }}</span>
						</el-form-item>
						<el-form-item label="指导价">
							<span>￥{{ props.row.price }}</span>
						</el-form-item>
					

						<el-form-item label="排序级别">
							<span>{{ props.row.sort }}</span>
						</el-form-item>
						<el-form-item label="商品简单描述">
							<span>{{ props.row.remark?props.row.remark:'无' }}</span>
						</el-form-item>
						<el-form-item label="商品详细描述">
							<el-button size="small" type="text" @click="findDetail(props.row.detail,1)">点击查看</el-button>
						</el-form-item>
						<el-form-item label="商品图片">
							<el-button size="small" type="text" @click="findDetail(props.row.images,2)">点击查看</el-button>
						</el-form-item>
					</el-form>
				</template>
			</el-table-column>
			<el-table-column prop="goodsId" label="商品ID" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="goodsName" label="商品名称" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<!-- 	<el-table-column prop="storeName" label="店铺名称" align="center" :show-overflow-tooltip="true">
			</el-table-column> -->
			<el-table-column v-if="storeType!=2" prop="storeName" label="供应商名称" align="center" :show-overflow-tooltip="true">
			</el-table-column>
		
			
			<el-table-column prop="status" label="商品状态" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<p v-if="scope.row.status==0">下架</p>
					<p v-if="scope.row.status==1">上架</p>
				</template>
			</el-table-column>

			<el-table-column prop="stock" label="库存" align="center" :show-overflow-tooltip="true">
			</el-table-column>
	
			<el-table-column prop="agreementPrice" label="协议价" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="price" label="指导价" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			
			<el-table-column label="操作" align="center">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="dialogVisibleFun(scope.row.id)">编辑</el-button>　　
					<el-dropdown trigger="click" style="margin-left: 10px;">
						<el-button type="text" size="small">更多</el-button>
						<el-icon class="el-icon-caret-bottom"></el-icon>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item @click.native="storeGoodsHitTheShelfOrSoldOut(scope.row.id,1)"
								v-if="scope.row.status==0 ">上架</el-dropdown-item>
							<el-dropdown-item @click.native="storeGoodsHitTheShelfOrSoldOut(scope.row.id,0)"
								v-if="scope.row.status==1 ">下架</el-dropdown-item>
						
							<el-dropdown-item @click.native="toDelete(scope.row.id)">删除</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>　　
				</template>　
			</el-table-column>
		</el-table> 
		<!-- 分页 -->
		<el-pagination style="margin: 20px auto;width:100%;" background :current-page="goodsList.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="goodsList.total"
			@size-change="handleSizeChange">
		</el-pagination>
		<!-- 详情查看 -->
		<el-dialog style="float:rigin" title="详情查看" :closeOnClickModal="false" :visible.sync="dialogVisibleDetails"
			width="50%">
			<div class="detailImg" v-if="detailType == 1" v-html="detail"></div>
			<div v-if="detailType == 2"
				style="display: flex;align-items: center;justify-content: space-between;flex-wrap: wrap;">
				<img style="width:40%;margin: 20px;" :src="image" v-for="(image,index) in  images" :key="index" />
			</div>
			<div style="text-align: center;">
				<el-button type="primary" @click="dialogVisibleDetails = false">关 闭</el-button>
			</div>
		</el-dialog>
		<!-- 编辑商家 -->
		<el-dialog title="编辑商品" :visible.sync="dialogbhVisible" :close-on-click-modal="false">
			<el-form :model="form">
				<el-form-item label="商品名称:">
					<el-span>{{form.goodsName}}</el-span>
				</el-form-item>
				<el-form-item label="商品图片:">
					<img :src="form.images.split(',')[0]" alt="" style="width: 100px;">
				</el-form-item> 
				<el-form-item label="商品编号:">
					<el-span>{{form.goodsCode}}</el-span>
				</el-form-item>
				<el-form-item label="协议价:">
					<el-span>￥{{form.agreementPrice}}</el-span>
				</el-form-item>    
				
				
				<el-form-item label="指导价:">
					<el-input style="width: 50%;" v-model="form.price" type="number" autocomplete="off" placeholder="请输入指导价(零售价)"></el-input>
				</el-form-item>
				<el-form-item label="排序:">
					<el-input  style="width: 20%;margin-left: 12px;margin-right: 10px;" v-model="form.sort" type="number" autocomplete="off" placeholder="请输入排序号"></el-input>
					数值越大，排序越靠前
				</el-form-item>
				<el-form-item  label="是否上架:">
					<el-switch
					  v-model="form.status"
					  active-color="#13ce66"
					  inactive-color="#7f7f7f" style="padding-top: 10px;">
					</el-switch>
				</el-form-item>
				
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogbhVisible = false">取 消</el-button>
				<el-button type="primary" @click="suredetail">确 定</el-button>
			
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		uploadFile
	} from "@/api/axios.js";
	var urls = uploadFile();


	export default {
		
		data() {
			return {
				form:{
					images:''
				},
				searchInfo:{},
				page: {
					pageNum: 1,
					pageSize: 10
				},
				goodsList:{},
				detail:'',
				images:'',
				dialogVisibleDetails:false,
				detailType:'',
				loading: false,
				dialogbhVisible:false,
				classGoods1List: [],
				classGoods2List: [],
				classGoods3List: [],
				classGoods1Id: "",
				classGoods2Id: "",
				classGoods3Id: "",
				storeList:[],
				storeType:''
			
			};
		},

		methods: {
			goxuanp(){
				     let routeUrl = this.$router.resolve({
				         path: "/goxuanpin",
				       
				       });
				         //let routeUrl = this.$router.resolve(`/share/${96}`)
				       window.open(routeUrl.href, '_blank');
				    

			},
			pageChange(data) {
					// console.log(data);
				this.page.pageNum = data
				this.getgoods();
			},
			handleSizeChange(val) {
			
				this.page.pageSize = val
				this.getgoods()
			},
			
			getStoreList() {
				this.$api.getStoreList(this.$encrypt({
					storeType: 1
				})).then(res => {
					res.data=JSON.parse(this.$decrypt(res.data)).data
					// console.log(res.data);
					if (res.state == 'success') {
						this.storeList = res.data.list;
						// console.log(this.storeList);
					}
				})
			},
			//选中一级分类
			classGoods1(e) {
				// console.log(e)
				this.classGoods2Id = "";
				this.classGoods3Id = "";
				this.classGoods3List = {};
				this.classGoods1Id = e
			
			
				this.searchInfo.classIdOne = e
				if (e) {
					this.$api.goodsClassfindByPid({
						pid: e
					}).then((res) => { //商品三级分类
						if (res.state == 'success') {
							this.classGoods2List = res.data;
						}
					})
				}
			},
			//选中二级分类
			classGoods2(e) {
				// console.log(e)
				this.searchInfo.classIdTwo = e
				this.classGoods3Id = "";
				this.classGoods2Id = e
				this.classGoods3List = {};
				if (e) {
					this.$api.goodsClassfindByPid({
						pid: e
					}).then((res) => { //商品三级分类
						if (res.state == 'success') {
							this.classGoods3List = res.data;
						}
					})
				}
			},
			//选中三级分类
			classGoods3(e) {
				// console.log(e)
				this.searchInfo.classId = e
				let obj = {};
				this.classGoods3Id = e
			
			},
			toDelete(id){
				// console.log(id);
				var str = "此操作将删除该商品, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.delGood(id).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.getgoods();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			
			},
			suredetail(){
				this.$api.updGood(this.$encrypt(this.form)).then(res=>{
					// console.log(res);
					if(res.state=='success'){
					this.$message({
						message: res.message,
						type: 'success'
					});
						this.dialogbhVisible = false
						this.getgoods()
					}
				})
			},
			storeGoodsHitTheShelfOrSoldOut(id,status){
				this.$api.delcGood(id).then(res=>{
					// console.log(res);
					if(res.state=='success'){
					this.$message({
						message: res.message,
						type: 'success'
					});
						this.dialogbhVisible = false
						this.getgoods()
					}
				})
			},
			dialogVisibleFun(id){
				this.dialogbhVisible=true
				this.$api.findGoods(this.$encrypt({id:id})).then(res=>{
					// console.log(res);
					res.data=JSON.parse(this.$decrypt(res.data)).data
						this.form=res.data.list[0]
				})
			},
			search(){
				this.page.pageNum=1
				this.getgoods()
			},
			empty(){
				this.searchInfo={}
				this.classGoods1Id=''
				this.classGoods2Id=''
				this.classGoods3Id=''
			},
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
		findDetail(string, type) {
			// console.log(string);
			this.dialogVisibleDetails = true;
			this.detailType = type;
			if (type == 1) {
				this.detail = string;
		
			}
			if (type == 2) {
				this.images = string.split(",");
			}
		},
		getgoods(){
			this.$api.findGoods(this.$encrypt({
			pageNum: this.page.pageNum,
			pageSize: this.page.pageSize,
			...this.searchInfo
			})).then((res) => { 
				res.data=JSON.parse(this.$decrypt(res.data)).data
				// console.log(res);
				this.goodsList=res.data
				
			})
		},
		},
		created() {
		this.getgoods()
			this.getStoreList()
			this.$api.goodsClassfindByPid({
				pid: 0
			}).then((res) => { //商品一级分类
				if (res.state == 'success') {
					this.classGoods1List = res.data;
				}
			})
			this.storeType=localStorage.getItem('storeType')
		
		}

	};
</script>

<style>
	.demo-table-expand {
		font-size: 0;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		width: 100px;
		height: 100px;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}


	.avatar-uploader1 .el-upload {
		border: 1px dashed #d9d9d9;
		width: 200px;
		height: 100px;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 100px;
		height: 100px;
		line-height: 100px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}

	.detailImg img {
		width: 100%;
	}

	.redItem {
		display: flex;
		flex-direction: row;
		align-items: center;
	}
</style>
